export enum AlertType {
    MISSING_INHIBITOR_QUESTIONNAIRE = 279,
}

// a type for specific context data needed per Alert type id
export type AlertTypeContextData = {
    [AlertType.MISSING_INHIBITOR_QUESTIONNAIRE]: {
        portCallId: number;
        alertSourceDate?: Date;
    };
};

export interface AlertCheckRequest {
    alertType: AlertType;
    contextData: AlertTypeContextData[AlertType];
}

export interface AlertData {
    alertTypeId: number;
    alertSource: string;
    alertType: string;
    vesselName: string;
    imoNumber: number;
    value: number;
    limit: number;
    highSeverity: boolean;
    cargoNumber?: string;
    alertSourceDate?: Date;
}
